import type {
  ReqParameters,
  ReqPathParameters,
  ReqQueryParameters,
  ReqType,
  ResType,
  UrlPaths,
} from "@fanka/openapi-typescript";
import * as fetch from "@on-site/libs/fetch";
import { Options } from "@on-site/libs/fetch/type";

function get<Path extends UrlPaths>(
  path: Path,
  options?: Options<{ path?: ReqPathParameters<Path, "get">; query?: ReqQueryParameters<Path, "get"> }>,
) {
  return fetch.get<ResType<Path, "get">>(path, options);
}

function post<Path extends UrlPaths>(
  path: Path,
  body: ReqType<Path, "post">,
  options?: Options<{ path?: ReqPathParameters<Path, "post"> }>,
) {
  return fetch.post<ReqType<Path, "post">, ResType<Path, "post">>(path, body, options);
}

function put<Path extends UrlPaths>(
  path: Path,
  body: ReqType<Path, "put">,
  options?: Options<{ path?: ReqPathParameters<Path, "put"> }>,
) {
  return fetch.put<ReqType<Path, "put">, ResType<Path, "put">>(path, body, options);
}

//deleteはJSの予約語であるためdestroyとする
function destroy<Path extends UrlPaths>(
  path: Path,
  body: ReqType<Path, "delete">,
  options?: Options<ReqParameters<Path, "delete">>,
) {
  return fetch.destroy<ReqType<Path, "delete">, ResType<Path, "delete">>(path, body, options);
}

export const appApiClient = { get, post, put, destroy };
